import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import { EmptyState } from './EmptyState';

/**
 * Rendered by {@link import('./AccessGatePage').AccessGatePage} when the
 * federated access provider resolves a genuine, authenticated corporate
 * session that simply lacks this application's entitlement role (see
 * `src/access/federatedAccessProvider.ts`). Deliberately a **different**
 * component from {@link import('./NoSessionPage').NoSessionPage}: the two
 * are different facts (no session at all vs. a real session without
 * access to this application) and must never be collapsed into one
 * message — see the wave brief this shipped with.
 *
 * Same discipline as `NoSessionPage`: no field, no submit button, no
 * credential of any kind. This is not a login screen and never becomes one.
 */
export function NotEntitledPage() {
  const translate = useTranslate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar
        position="static"
        color="inherit"
        elevation={0}
        sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
      >
        <Toolbar>
          <Typography
            component="span"
            sx={{ whiteSpace: 'nowrap', fontSize: '1.05rem', letterSpacing: '-0.3px', lineHeight: 1 }}
          >
            <Box component="span" sx={{ color: (theme) => theme.custom.wordmarkBrandColor, fontWeight: 800 }}>
              {translate('pay.appBar.wordmarkBrand')}
            </Box>
            <Box
              component="span"
              sx={{ color: (theme) => theme.custom.wordmarkProductColor, fontWeight: 500, ml: 0.75 }}
            >
              {translate('pay.appBar.wordmarkProduct')}
            </Box>
          </Typography>
        </Toolbar>
      </AppBar>
      <EmptyState
        icon={<BlockOutlinedIcon fontSize="inherit" />}
        title={translate('pay.notEntitled.title')}
        body={translate('pay.notEntitled.body')}
      />
    </Box>
  );
}
